import { useState, useEffect } from 'react'
import './Toaster.css'

export default function Toaster({ notifications, onAccept, onDecline, onDismiss }) {
  const [visibleNotifications, setVisibleNotifications] = useState([])

  useEffect(() => {
    // Add new notifications with a fade-in effect
    notifications.forEach(notification => {
      if (!visibleNotifications.some(visible => visible.id === notification.id)) {
        setVisibleNotifications(prev => [...prev, { ...notification, isVisible: true }])

        // Auto-dismiss non-action notifications after 12 seconds (longer for challenges)
        if (!notification.hasActions) {
          setTimeout(() => {
            dismissNotification(notification.id)
          }, 12000)
        }
      }
    })
  }, [notifications])

  const dismissNotification = (id) => {
    // Fade out animation
    setVisibleNotifications(prev =>
      prev.map(notif =>
        notif.id === id ? { ...notif, isVisible: false } : notif
      )
    )

    // Remove from DOM after animation
    setTimeout(() => {
      setVisibleNotifications(prev => prev.filter(notif => notif.id !== id))
      if (onDismiss) onDismiss(id)
    }, 300)
  }

  const handleAccept = (notification) => {
    if (onAccept) onAccept(notification)
    dismissNotification(notification.id)
  }

  const handleDecline = (notification) => {
    if (onDecline) onDecline(notification)
    dismissNotification(notification.id)
  }

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'challenge':
      case 'game_invite':
        return '⚔️'
      case 'friend_request':
        return '👥'
      case 'friend_accepted':
        return '✅'
      case 'game_result':
        return '🏆'
      case 'tournament':
        return '🏆'
      default:
        return '🔔'
    }
  }

  return (
    <div className="toaster-container">
      {visibleNotifications.map(notification => (
        <div
          key={notification.id}
          className={`toaster-notification simple ${notification.isVisible ? 'visible' : 'hidden'}`}
        >
          <div className="toaster-simple-content">
            <div className="toaster-icon">
              {getNotificationIcon(notification.type)}
            </div>
            <div className="toaster-simple-text">
              <strong>{notification.title}</strong>
              <br />
              {notification.message}
            </div>

            {/* Show Accept/Decline/Join for challenge and tournament notifications */}
            {(notification.type === 'challenge' || notification.type === 'tournament') && notification.hasActions ? (
              <div className="toaster-challenge-actions">
                <button
                  className="toaster-accept-btn"
                  onClick={() => {
                    handleAccept(notification)
                  }}
                >
                  ✓ Accept
                </button>
                <button
                  className="toaster-decline-btn"
                  onClick={() => {
                    handleDecline(notification)
                  }}
                >
                  ✗ Decline
                </button>
                <button
                  className="toaster-join-game-btn"
                  onClick={() => {
                    // Navigate directly to the game
                    if (notification.data?.game_id) {
                      if (window.navigateToGame) {
                        window.navigateToGame(notification.data.game_id)
                      } else {
                        window.dispatchEvent(new CustomEvent('navigate-to-game', {
                          detail: { gameId: notification.data.game_id }
                        }))
                      }
                      dismissNotification(notification.id)
                    } else {
                      console.error('No game_id found in notification data')
                    }
                  }}
                >
                  🎯 Join Game
                </button>
              </div>
            ) : (
              // Show View Notifications for other types
              <button
                className="toaster-view-notifications"
                onClick={() => {
                  // Try multiple navigation methods
                  if (window.navigateToNotifications) {
                    window.navigateToNotifications()
                  } else {
                    // Dispatch custom event for Dashboard to listen
                    window.dispatchEvent(new CustomEvent('navigate-to-notifications'))
                  }
                  dismissNotification(notification.id)
                }}
              >
                View Notifications
              </button>
            )}

            <button
              className="toaster-close"
              onClick={() => dismissNotification(notification.id)}
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}